import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationModalComponent } from './components/notification-modal/notification-modal';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('HOTEL');
}
